import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'
interface UseRedeemRewardItemProps {
  id?: string,
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

const useRedeemRewardItem = ({ id, onSuccess, onError }: UseRedeemRewardItemProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['redeemRewardItem'],
    mutationFn: async () => {
      return privateAxios.post(`/tmais/reward_product_redemptions/${id}/redeem`)
    },
    onSuccess,
    onError,
  })
}

export default useRedeemRewardItem
